import { TableColumn } from "../pages/ListReceipt";

export const columns: TableColumn[] = [
  { key: "image", header: "Image" },
  { key: "memberName", header: "Member" },
  { key: "merchantName", header: "Merchant Name" },
  { key: "loyaltyCardNo", header: "Loyalty Card No." },
  { key: "reviewed_by", header: "Reviewed by" },
  { key: "amountMember", header: "Uploaded Amount" },
  { key: "receiptNumber", header: "Receipt Number" },
  { key: "amountBpo", header: "Adjusted Amount" },
  { key: "yuuAmount", header: "yuu amount" },
  { key: "paymentType", header: "Payment Type" },
  // { key: 'amountBpo', header: 'Updated Amount'  },
  { key: "submissionDate", header: "Submitted Date" },
  { key: "receiptDate", header: "Receipt Date" },
  { key: "reviewedDate", header: "Reviewed Date" },
  { key: "rejectionDate", header: "Reject Date" },
  { key: "status", header: "Status" },
  { key: "receiptType", header: "Receipt Type" },
  { key: "evoucherAmount", header: "Evoucher Amount" },
  { key: "evoucherCode", header: "Evoucher Code" },
  { key: "physicalVoucherAmount", header: "Physical Voucher Amount" },
  { key: "physicalVoucherCode", header: "Physical Voucher Code" },
  { key: "remark", header: "Remark" },
  { key: "points", header: "Points" },
  // { key: 'tallyCheck', header: 'Tally Check' },
  // { key: 'tallyCheckMessage', header: 'Tally Check Message' },
];

export const metaData = {
  image: {
    isImage: true,
    linkTo: "",
  },
  memberName: {
    isImage: false,
    linkTo: "",
  },
  memberId: {
    isImage: false,
    linkTo: "",
  },
  loyaltyCardNo: {
    isImage: false,
    linkTo: "",
  },
  amountBpo: {
    isImage: false,
    linkTo: "",
  },
  amountMember: {
    isImage: false,
    linkTo: "",
  },
  submissionDate: {
    isImage: false,
    linkTo: "",
  },
  reviewedDate: {
    isImage: false,
    linkTo: "",
  },
  rejectionDate: {
    isImage: false,
    linkTo: "",
  },
  tallyCheck: {
    isImage: false,
    linkTo: "",
  },
  tallyCheckMessage: {
    isImage: false,
    linkTo: "",
  },
  status: {
    isImage: false,
    linkTo: "",
  },
  receiptType: {
    isImage: false,
    linkTo: "",
  },
  evoucherAmount: {
    isImage: false,
    linkTo: "",
  },
  evoucherCode: {
    isImage: false,
    linkTo: "",
  },
  physicalVoucherAmount: {
    isImage: false,
    linkTo: "",
  },
  physicalVoucherCode: {
    isImage: false,
    linkTo: "",
  },
  points: {
    isImage: false,
    linkTo: "",
  },
};
